var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.152 3.79195L8 10.9439L0.848 3.79195C0.752 3.69595 0.634667 3.64795 0.496 3.64795C0.357333 3.64795 0.24 3.69595 0.144 3.79195C0.048 3.88795 0 4.00528 0 4.14395C0 4.28262 0.048 4.39995 0.144 4.49595L8 12.3519L15.856 4.49595C15.952 4.39995 16 4.28262 16 4.14395C16 4.00528 15.952 3.88795 15.856 3.79195C15.76 3.69595 15.6427 3.64795 15.504 3.64795C15.3653 3.64795 15.248 3.69595 15.152 3.79195Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowDropdown);
export default __webpack_public_path__ + "static/media/down-arrow-dropdown.0a19ba827a063c9a481080d8c6d47eff.svg";
export { ForwardRef as ReactComponent };